import { useEffect, useRef } from "react";
import { titleManager } from "./TitleManager";

const getDefaultTitle = (): string => {
  return window.initialWsData?.pageTitle ?? "Creator SaaS";
};

const sanitizeTitle = (title?: string): string | undefined => {
  if (!title) return title;

  if (title.includes("undefined")) {
    return getDefaultTitle();
  }

  return title;
};

export function usePageTitle(title?: string): void {
  const idRef = useRef<string>();

  if (!idRef.current) {
    idRef.current = crypto.randomUUID();
  }

  const sanitizedTitle = sanitizeTitle(title);

  useEffect(() => {
    const id = idRef.current!;

    titleManager.push(id, sanitizedTitle);

    return () => {
      titleManager.remove(id);
    };
  }, []);

  useEffect(() => {
    const id = idRef.current!;
    titleManager.update(id, sanitizedTitle);
  }, [sanitizedTitle]);
}
